import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeAlpha';
const args = {};

export class ModeAlpha extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
